import { render, staticRenderFns } from "./NewBusinessComponent.vue?vue&type=template&id=4e6d1d62&scoped=true"
import script from "./NewBusinessComponent.vue?vue&type=script&lang=js"
export * from "./NewBusinessComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d1d62",
  null
  
)

export default component.exports